import type {} from '@angular/localize/init';
import type { TranslationConfig } from '../i18n-cache';
import { appRoutesI18nCache } from '../i18n-cache';

export function supportRouteI18n(config?: TranslationConfig): string {
  if (config?.translateForLang && globalThis.$localizeForLang) {
    return globalThis.$localizeForLang`:url-segment@@support-url-segment:support`;
  }
  return (appRoutesI18nCache['help'] ??= $localize`:url-segment@@support-url-segment:support`);
}
